import { gql } from "@apollo/client";

export const GET_FAQ_TABS = gql`
  query ($sort: String, $direction: String) {
    faqTabs(sort: $sort, direction: $direction) {
      id
      name {
        lang
        value
      }
      page
    }
  }
`;

export const GET_FAQ_TAB = gql`
  query ($id: Int) {
    faqTabs(id: $id) {
      id
      name {
        lang
        value
      }
      page
    }
  }
`;

export const GET_FAQS = gql`
  query ($tab_id: Int, $sort: String, $direction: String) {
    faq(tab_id: $tab_id, sort: $sort, direction: $direction) {
      id
      title {
        lang
        value
      }
      tab {
        id
        name {
          lang
          value
        }
      }
      status
    }
  }
`;

export const GET_FAQ = gql`
  query ($id: Int, $lang: String!) {
    faq(id: $id) {
      id
      title {
        lang
        value
      }
      text {
        lang
        value
      }
      tab {
        id
      }
      status
    }
    faqTabs {
      id
      nameString(lang: $lang)
    }
  }
`;
